<template>
  <nav class="menu">
    <ul>
      <li v-if="!isLoggedIn" :class="store.page=='env'?'active':''"><a href="#" @click.stop="navigate('env')">Environment</a></li>
      <li v-if="isLoggedIn" :class="menuClass('raffle')"><a href="#" @click.stop="navigate('raffle')">Raffle</a></li>
      <li v-if="isLoggedIn" :class="menuClass('jackpot')"><a href="#" @click.stop="navigate('jackpot')">Jackpot</a></li>
      <li v-if="isLoggedIn" :class="menuClass('instant')"><a href="#" @click.stop="navigate('instant')">Instant</a></li>
      <li v-if="isLoggedIn" :class="menuClass('lotto')"><a href="#" @click.stop="navigate('lotto')">Lotto</a></li>
      <li v-if="isLoggedIn" :class="menuClass('winlose')"><a href="#" @click.stop="navigate('winlose')">Win/Lose</a></li>
      <!-- <li v-if="isLoggedIn" :class="store.page=='probability'?'active':''"><a href="#" @click.stop="navigate('probability')">Probability</a></li> -->
      <li v-if="isLoggedIn" :class="menuClass('cashout')"><a href="#" @click.stop="navigate('cashout')">Cashout</a></li>
      <li v-if="isLoggedIn" :class="menuClass('crash')"><a href="#" @click.stop="navigate('crash')">Crash</a></li>
      <li v-if="isLoggedIn" :class="menuClass('gamification')"><a href="#" @click.stop="navigate('gamification')">Gamification</a></li>
      <li v-if="isLoggedIn" :class="menuClass('transactions')"><a href="#" @click.stop="navigate('transactions')">Transactions</a></li>
    </ul>
  </nav>
</template>

<script>
import store from '../store.js';

export default {
  name: 'MainMenu',
  props: {
  },
  computed: {
    isLoggedIn() {
      return !!store.user?.access_token;
    },
    isReady() {
      return !!store.clientConfig;
    }
  },
  data() {
    return {
      store: store,
    }
  },
  methods: {
    menuClass(page) {
      return {
        active: store.page === page,
        disabled: this.isLoggedIn && !this.isReady
      };
    },
    navigate(_newpage) {
      if (this.isLoggedIn && !this.isReady) return false;
      store.page = _newpage;
      return false;
    }
  }
}
</script>

<style scoped>
nav.menu {
  width: 100%;
  display: flex;
  background: var(--color-blue);
  color: var(--color-text-light);
}
nav.menu ul {
  display: flex;
  padding-left: 10px;
}
nav.menu ul a {
  text-decoration: none;
  color: var(--color-text-light);
}
nav.menu ul li.active a {
  text-decoration: underline;
}
nav.menu ul li.disabled a {
  opacity: 0.6;
  cursor: not-allowed;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
